import type { Page } from '../../types';

const coverSheet: Page[] = [
  {
    pageType: 'question',
    title: 'Tenant details',
    name: 'tenant-details',
    description: 'Complete the base details for this tenant.',
    questions: [
      {
        questionType: 'textInput',
        title: 'Contact email',
        name: 'contact-email',
        rules: {
          required: true,
          email: true,
        },
      },
    ],
  },
];

export default coverSheet;
